import Swal from "sweetalert2";
import type { App } from "vue";

interface ToastOptions {
  message: string;
  icon: "success" | "error" | "warning" | "info" | "question";
  timer?: number;
  toastClass?: string;
  offsetX?: number | null; // null なら位置上書きしない
  offsetY?: number | null;
}

export default {
  install(app: App): void {
    app.config.globalProperties.$toast = (options: ToastOptions) => {
      const timer = options.timer ?? 2500;
      const toastClass = options.toastClass ?? "toast-default-style";

      // PC/SP 判定
      const isSP = window.matchMedia("(max-width: 767px)").matches;

      // PCのときは<br>タグを削除
      const message = isSP
        ? options.message
        : options.message.replace(/<br\s*\/?>/gi, " ");

      Swal.fire({
        toast: true,
        icon: options.icon,
        html: `<span>${message}</span>`,
        showConfirmButton: false,
        timer,
        customClass: {
          popup: toastClass,
        },
        didOpen: (toast) => {
          if (options.offsetX != null && options.offsetY != null) {
            requestAnimationFrame(() => {
              const top = options.offsetY!;
              const left = options.offsetX!;

              toast.style.setProperty("position", "fixed", "important");
              toast.style.setProperty("top", `${top}px`, "important");
              toast.style.setProperty("left", `${left}px`, "important");
              toast.style.setProperty("margin", "0", "important");
              toast.style.setProperty("transform", "none", "important");
              toast.style.setProperty("right", "auto", "important");
              toast.style.setProperty("z-index", "9999", "important");
              toast.style.setProperty("bottom", "auto", "important");
            });
          }
        },
      });
    };
  },
};
